import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/element.js'
import '@/styles/index.scss' // global css
import './styles/element-variables.scss'
import { bootstrapTrackingIdentity, trackEvent } from '@/utils/track'

Vue.config.productionTip = false
Vue.prototype.$trackEvent = trackEvent

bootstrapTrackingIdentity().catch((error) => {
  console.error('[track] bootstrap failed', error)
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')



